<div class="dynamic-content-page">
  <!-- Account Bar -->
  <app-account-bar *ngIf="sessionQuery.getValue()" [user]="sessionQuery.getValue()"></app-account-bar>

  <!-- Loading State -->
  <div *ngIf="loading" class="loading-container">
    <mat-spinner diameter="60"></mat-spinner>
    <p class="loading-text">Loading page content...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="error && !loading" class="error-container">
    <mat-card class="error-card">
      <mat-card-content>
        <mat-icon color="warn">error_outline</mat-icon>
        <h2>Unable to Load Page</h2>
        <p>{{ error }}</p>
        <button mat-raised-button color="primary" (click)="reload()">
          <mat-icon>refresh</mat-icon>
          Try Again
        </button>
      </mat-card-content>
    </mat-card>
  </div>

  <!-- Page Content -->
  <div *ngIf="page && !loading && !error" class="page-content">
    <!-- Admin Edit Bar (only shown to admins) -->
    <div *ngIf="contextState.user?.isAtLeastAdmin" class="admin-bar">
      <div class="admin-bar-content">
        <div class="admin-info">
          <mat-icon>edit</mat-icon>
          <span>Editing: <strong>{{ pageTitle }}</strong></span>
          <mat-chip-list>
            <mat-chip [color]="page.isPublished ? 'primary' : 'basic'" selected>
              {{ page.isPublished ? 'Published' : 'Draft' }}
            </mat-chip>
          </mat-chip-list>
        </div>
        <div class="admin-actions">
          <button mat-stroked-button color="secondary" [routerLink]="['/settings/admin-content-pages']">
            <mat-icon>settings</mat-icon>
            Manage Pages
          </button>
        </div>
      </div>
    </div>

    <!-- Content Sections Container -->
    <div class="content-sections-wrapper">
		<app-content-section-container
          [usageContext]="pageSlug"
          [contextState]="contextState"
          (selectedListing)="handleTemplateSelection($event)"
        ></app-content-section-container>
    </div>
  </div>

  <!-- 404 State (when no page is resolved) -->
  <div *ngIf="!page && !loading" class="not-found-container">
    <mat-card class="not-found-card">
      <mat-card-content>
        <mat-icon>search_off</mat-icon>
        <h1>Page Not Found</h1>
        <p>The page you're looking for doesn't exist or has been removed.</p>
        <button mat-raised-button color="primary" routerLink="/">
          <mat-icon>home</mat-icon>
          Go to Homepage
        </button>
      </mat-card-content>
    </mat-card>
  </div>
</div>
